import { IconButton, styled, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Link, useLocation } from "react-router-dom";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const Outer = styled("div")(props => ({ cursor: "pointer", paddingLeft: 16, paddingRight: 16, paddingTop: 4, paddingBottom: 4, overflow: "hidden", marginRight: 10, minWidth: 180, opacity: props.disabled ? 0.6 : undefined, backgroundColor: props.disabled ? grey["100"] : props.selected ? grey["300"] : "", border: "1px solid " + (props.selected ? grey["300"] : "transparent"), borderTopRightRadius: 15, borderBottomRightRadius: 15, borderLeft: "none", position: "relative", "&:hover": { backgroundColor: grey["200"] } }));
const ChildMatchContext = /*#__PURE__*/ createContext({ renderId: "", isMatch: (match, path, renderId) => { } });
const prevChildMatched = {};
const prevExpanded = {};
export function SidebarItem(props) {
    const [expanded, setExpanded] = useState(prevExpanded[props.link] || false);
    const [childMatches, setChildMatches] = useState(prevChildMatched[props.link] || false); // prevent flicker
    prevExpanded[props.link] = expanded;
    prevChildMatched[props.link] = childMatches;
    const loc = useLocation();
    const selected = (() => { if (!props.link)
        return false; if (props.noMatchChildren)
        return loc.pathname === props.link; return loc.pathname.startsWith(props.link); })();
    const ctx = useContext(ChildMatchContext);
    useEffect(() => {
        ctx.isMatch(selected, props.link, ctx.renderId); // notify parent of match
    });
    const hasExpander = !!props.children;
    const hasLink = !!props.link;
    useEffect(() => { setExpanded(selected || childMatches); }, [selected, childMatches, hasExpander]);
    const renderId = Date.now().toString();
    const matchesRef = useRef({});
    matchesRef.current = {};
    const [checkOnChildMatches, setCheckOnChildMatches] = useState(false); // auto reset childMatches when child a is no longer selected after 700ms
    useEffect(() => {
        if (!checkOnChildMatches)
            return;
        const timeout = setTimeout(() => {
            for (let k in matchesRef.current) {
                if (matchesRef.current[k] === true)
                    return;
            }
            setChildMatches(false);
            setCheckOnChildMatches(false);
        }, 700);
        return () => clearTimeout(timeout);
    }, [checkOnChildMatches, props.name]);
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(Link, { to: props.disabled ? "" : props.link, style: { color: "inherit", textDecoration: "none" }, children: /*#__PURE__*/ _jsx(Outer, { selected: selected, disabled: props.disabled, onClick: e => { if (hasExpander && !hasLink) {
                        e.preventDefault();
                        e.stopPropagation();
                        setExpanded(!expanded);
                    } }, children: /*#__PURE__*/ _jsx(Tooltip, { title: props.name || "", placement: "right", children: /*#__PURE__*/ _jsxs("div", { style: { display: "flex", paddingLeft: props.indent ? props.indent * 18 : undefined }, children: [/*#__PURE__*/ _jsx("div", { style: { paddingRight: 16, overflow: "hidden", fontSize: "1.3rem", height: "1em" }, children: props.icon }), /*#__PURE__*/ _jsxs("div", { style: { maxWidth: 100, overflow: "hidden" }, children: [/*#__PURE__*/ _jsx("div", { style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: props.name }), props.subtitle && /*#__PURE__*/ _jsx("div", { style: { fontSize: "0.7rem", lineHeight: "1em", opacity: 0.7 }, children: props.subtitle })] }), hasExpander ? /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx("div", { style: { width: 16 } }), /*#__PURE__*/ _jsx(IconButton, { size: "small", style: { position: "absolute", right: 0, top: 0 }, onClick: e => { e.preventDefault(); e.stopPropagation(); setExpanded(!expanded); }, children: /*#__PURE__*/ _jsx(KeyboardArrowDownIcon, {}) })] }) : null] }) }) }) }), /*#__PURE__*/ _jsx("div", { style: { height: expanded ? undefined : 0, overflow: expanded ? undefined : "hidden" }, children: /*#__PURE__*/ _jsx(ChildMatchContext.Provider, { value: { renderId: renderId, isMatch: (match, path, childRenderId) => {
                            if (childRenderId !== renderId) {
                                console.log("old render", childRenderId, renderId);
                                return; // old render
                            }
                            matchesRef.current[path] = match;
                            if (match) { // trigger matches early
                                setChildMatches(true);
                                setCheckOnChildMatches(false);
                                return;
                            }
                            for (let k in matchesRef.current) {
                                if (matchesRef.current[k] === true) {
                                    return;
                                }
                            }
                            if (childMatches) { // no matches
                                setCheckOnChildMatches(true);
                            }
                        } }, children: props.children }) })] });
}
